import React from 'react';
import queryString from 'query-string';
import { useParams } from 'react-router-dom';
import Walls20 from './index';
import WallsAsPage from '../walls_as_page';
import { VALID_QUERY_PARAMS } from '../walls/shared';

export const clearFilters = (params, skipParam = null) => {
  const out = {};
  VALID_QUERY_PARAMS.forEach(key => {
    const val = params[key];
    if (val && key !== skipParam) {
      out[key] = val;
    }
  });

  return out;
};

const WallsSwitcher = (props) => {
  const extraParams = queryString.parse(window.location.search);
  const params = { ...useParams(), ...extraParams };
  const activeFilters = clearFilters(params);
  const { as } = params;
  const wProps = {
    ...props, activeFilters, ...params
  };

  if (as === 'page') {
    return <WallsAsPage { ...wProps } />;
  }

  return <Walls20 { ...props } />;
};

export default WallsSwitcher;
